import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import CreateAdhoc from './createOnline';
import CreateOffline from './createOffline.js';

class CreateTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            testMode: this.getTestModeFromProps(),
            currentStep: 1
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.editExamType !== this.props.editExamType || 
            prevProps.cloneExamType !== this.props.cloneExamType) {
            this.setState({
                testMode: this.getTestModeFromProps(),
                currentStep: 1
            });
        }
    }

    getTestModeFromProps = () => {
        if (this.props.editExamId && this.props.editExamType) {
            return this.props.editExamType === 'OfflineTest' ? 'offline' : 'online';
        }
        if (this.props.cloneExamData && this.props.cloneExamType) {
            return this.props.cloneExamType === 'OfflineTest' ? 'offline' : 'online';
        }
        return 'online';
    }

    // Handler to receive currentStep updates from CreateAdhoc component
    onStepChange = (step) => {
        this.setState({ currentStep: step });
    }

    // Helper method to determine dropdown visibility
    shouldShowDropdown = () => {
        const { testMode, currentStep } = this.state;
        const { editExamId, cloneExamData } = this.props;

        // Don't show if in edit mode or clone mode
        if (editExamId || cloneExamData) return false;

        // For offline mode, always show dropdown (no steps)
        if (testMode === 'offline') return true;

        // For online mode, hide dropdown when on step 2
        if (testMode === 'online' && currentStep === 2) return false;

        return true;
    }

    render() {
        const { testMode } = this.state;
        const { editExamId, cloneExamData, onCancel } = this.props;

        return (
            <div className='create-test-container'>
                {/* Header with cancel button for edit mode */}
                {(editExamId || cloneExamData) && onCancel && (
                    <div className="mb-3 flex justify-content-between align-items-center">
                        <h3>{editExamId ? 'Edit' : 'Clone'} {testMode === 'offline' ? 'Offline' : 'Online'} Exam</h3>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-outlined"
                            onClick={onCancel}
                        />
                    </div>
                )}

                {/* Test Mode Selection at the top - Show based on conditions */}
                {this.shouldShowDropdown() && (
                    <div className='ma-p20 paper-s1 mb-3'>
                        <div className="grid">
                            <div className="col-4">
                                <p className='ma-label-s2'>Test Mode<span className='ma-required'>*</span></p>
                                <Dropdown
                                    value={testMode}
                                    options={[
                                        { label: 'Online', value: 'online' },
                                        { label: 'Offline', value: 'offline' }
                                    ]}
                                    className='w-full'
                                    onChange={e => this.setState({ testMode: e.value, currentStep: 1 })}
                                    placeholder="Select Test Mode"
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Render appropriate component based on test mode */}
                {testMode === 'online' ? (
                    <CreateAdhoc {...this.props} onStepChange={this.onStepChange} />
                ) : (
                    <CreateOffline {...this.props} />
                )}
            </div>
        );
    }
}

export default CreateTest;